import React, { useState } from 'react';
import { Grid } from 'theme-ui';
import ContentSet from '~/components/Content/Section/ContentCard/ContentSet';
import chunk from 'lodash/chunk';
import SingleCard from '~/components/Content/Section/ContentCard/SingleCard';

const ContentCardSection = React.memo(function ContentCardSection({ contentCards }) {
  const [paused, outerPausedFunc] = useState(true);
  const cardSetArr = chunk(contentCards, 2);

  return (
    <Grid sx={{ rowGap: ['var(--gap)', null, '2rem'], height: '100%' }}>
      {cardSetArr.map((cardSet) => {
        return cardSet.length % 2 === 0 ? (
          <ContentSet key={`${cardSet[0].id}-group`} contentCards={cardSet} />
        ) : (
          <SingleCard
            key={cardSet[0].id}
            contentCard={cardSet[0]}
            single={true}
            forwardSx={{
              mx: paused && [cardSet[0].fullWidth ? 0 : '1rem', '1rem', '2rem'],
              borderTopLeftRadius: paused && [0, 2],
              borderBottomRightRadius: paused && [0, 4],
            }}
            outerPausedFunc={outerPausedFunc}
          />
        );
      })}
    </Grid>
  );
});

export default ContentCardSection;
